import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./DeliveryTools.module.scss";
import EMPTabs from "../../shared/components/EMPTabs/EMPTabs";
import { useLocation, useRouteMatch } from "react-router-dom";
import DownloadTool from "./pages/downloadTool/DownloadTool";
import PreDeliveryTasks from "./pages/dealerTasks/PreDeliveryTasks.js";
import { withTranslation } from "react-i18next";
import { ModalProvider } from "../../shared/components/EMPModal/ModalContext";
import { isRestrictedDeliveryToolsUser } from "../../utils/lincolnDeliveryPilot.js";

const DeliveryTools = (props) => {
  const { user, history, t } = props;
  const { url } = useRouteMatch();
  const location = useLocation();

  const isTasksOnlyUser = isRestrictedDeliveryToolsUser(user);
  const isTasksRoute = location.pathname === `${url}/tasks`;

  const [activeTab, setActiveTab] = useState(
    isTasksOnlyUser ? 0 : isTasksRoute ? 1 : 0
  );

  const standardTabItems = [
    {
      route: url,
      title: t("DeliveryTools.tabTitle1"),
      content: <DownloadTool user={user} />,
    },
    {
      route: `${url}/tasks`,
      title: t("DeliveryTools.tabTitle2"),
      content: <PreDeliveryTasks user={user} />,
    },
  ];

  const tasksOnlyTabItems = [
    {
      route: `${url}/tasks`,
      title: t("DeliveryTools.manageDeliveryPrepChecklist"),
      content: <PreDeliveryTasks user={user} />,
    },
  ];

  const tabItems = isTasksOnlyUser ? tasksOnlyTabItems : standardTabItems;

  useEffect(() => {
    if (isTasksOnlyUser && location.pathname !== `${url}/tasks`) {
      history.replace(`${url}/tasks`);
      setActiveTab(0);
      return;
    }

    setActiveTab(isTasksRoute ? 1 : 0);
  }, [history, isTasksOnlyUser, isTasksRoute, location.pathname, url]);

  const handleTabChange = (newTabIndex) => {
    const selectedTab = tabItems[newTabIndex];

    setActiveTab(newTabIndex);

    if (selectedTab?.route) {
      history.push(selectedTab.route);
    }
  };

  return (
    <ModalProvider>
      <section className={styles.pageContainer}>
        <div
          className={styles.tabsContainer}
          style={{ borderTop: "1px solid #e5e5e5" }}
        >
          <EMPTabs
            tabItems={tabItems}
            activeTab={isTasksOnlyUser ? 0 : activeTab}
            onTabChange={handleTabChange}
          />
        </div>
      </section>
    </ModalProvider>
  );
};

DeliveryTools.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({}).isRequired,
};

export default withTranslation("emp")(DeliveryTools);
